export default [
  {
    name: '__notifications_view',
    path: '/notifications/',
    redirect: {
      name: '__account_notifications_list'
    }
  }
]
